import React, { type FC } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import pluralize from 'pluralize';

import PageSection from 'src/components/page/PageSection';

const CURRENT_STREAK_TOOLTIP = 'Your current streak counts the number of consecutive weeks you have met your weekly activity goal.';

type Props = {
    streakWeeks: number;
};

const CurrentStreakSection: FC<Props> = ({ streakWeeks }) => {
    return (
        <PageSection variant="outlined">
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography fontWeight={700}>Current Streak</Typography>
                <Tooltip title={CURRENT_STREAK_TOOLTIP}>
                    <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                </Tooltip>
            </Box>
            <Box mt={2} display="flex" alignItems="center" gap={0.5}>
                <BoltRoundedIcon sx={{ color: 'warning.main' }} />
                <Typography variant="h4" fontWeight={700}>{streakWeeks}</Typography>
                <Typography color="text.secondary">{pluralize('week', streakWeeks)}</Typography>
            </Box>
            <Typography mt={1.5} color="text.secondary">
                Continue your current streak by completing 4 days of activities this week!
            </Typography>
        </PageSection>
    );
};

export default CurrentStreakSection;
